enum TimePeriod {
  "AM",
  "PM",
}

export default TimePeriod;
